/**
 * Deep View returns pre-formatted amounts as strings — "-$959.95", "+$0.00",
 * "£1,537.10" — so the sign has to be read back out of the text.
 */
export const isNegativeValue = (value: any) =>
  Number(String(value ?? "").replace(/[^0-9.-]/g, "")) < 0;

/** Everything that is not part of the number is the currency symbol */
const extractCurrencySymbol = (value: any) =>
  String(value ?? "")
    .replace(/[0-9.,\s+-]/g, "")
    .trim();

const parseAmount = (value: any) =>
  Number(String(value ?? "").replace(/[^0-9.-]/g, ""));

/**
 * Compares two pre-formatted amounts by value rather than by text, so
 * "$-5,031.00" and "$-5,031" count as the same number. Amounts in different
 * currencies are never equal — the numbers alone cannot be compared.
 */
export const areAmountsEqual = (a: any, b: any) => {
  const aMissing = a === null || a === undefined;
  const bMissing = b === null || b === undefined;
  if (aMissing || bMissing) return aMissing && bMissing;
  // Only a genuine conflict blocks the comparison: one side may arrive
  // unformatted ("0" alongside "$0"), which states no currency at all.
  const aSymbol = extractCurrencySymbol(a);
  const bSymbol = extractCurrencySymbol(b);
  if (aSymbol && bSymbol && aSymbol !== bSymbol) return false;
  const aAmount = parseAmount(a);
  const bAmount = parseAmount(b);
  // Fall back to text for anything that is not a number at all
  if (isNaN(aAmount) || isNaN(bAmount)) return String(a) === String(b);
  return aAmount === bAmount;
};
